const Transform = function(state) {
    var enabled = true;
    var on_translate = null;
    var on_scale = null;
    var on_change = null;
    var children = [];
    const propagate = () => {
        for (let child of children) {
            child.state = state;
        }
    };
    Object.defineProperty(this, "x", {
        set: (x) => {
            if (state.x === x) {
                return;
            }
            state.x = x;
            if (!enabled) {
                return;
            }
            if (on_translate !== null) {
                on_translate(state);
            }
            if (on_change !== null) {
                on_change(state);
            }
            propagate();
        },
        get: () => state.x
    });
    Object.defineProperty(this, "y", {
        set: (y) => {
            if (state.y === y) {
                return;
            }
            state.y = y;
            if (!enabled) {
                return;
            }
            if (on_translate !== null) {
                on_translate(state);
            }
            if (on_change !== null) {
                on_change(state);
            }
            propagate();
        },
        get: () => state.y
    });
    Object.defineProperty(this, "k", {
        set: (k) => {
            if (state.k === k) {
                return;
            }
            state.k = k;
            if (!enabled) {
                return;
            }
            if (on_scale !== null) {
                on_scale(state);
            }
            if (on_change !== null) {
                on_change(state);
            }
            propagate();
        },
        get: () => state.k
    });
    Object.defineProperty(this, "state", {
        set: ({x, y, k}) => {
            var translate = false, scale = false;
            if (x !== undefined && state.x !== x) {
                state.x = x;
                translate = true;
            }
            if (y !== undefined && state.y !== y) {
                state.y = y;
                translate = true;
            }
            if (k !== undefined && state.k !== k) {
                state.k = k;
                scale = true;
            }

            if (!enabled) {
                return;
            }
            if (translate && on_translate !== null) {
                on_translate(state);
            }
            if (scale && on_scale !== null) {
                on_scale(state);
            }
            if ((translate || scale) && on_change !== null) {
                on_change(state);
            }
            propagate();
        },
        get: () => state
    });
    this.on_translate = (handler) => {
        on_translate = handler;
    };
    this.on_scale = (handler) => {
        on_scale = handler;
    };
    this.on_change = (handler) => {
        on_change = handler;
    };
    this.append_child = (child) => {
        children.push(child);
    };
    this.enable = () => {
        if (enabled) {
            return;
        }
        enabled = true;
        if (on_translate !== null) {
            on_translate(state);
        }
        if (on_scale !== null) {
            on_scale(state);
        }
        if (on_change !== null) {
            on_change(state);
        }
        propagate();
    };
    this.disable = () => {
        enabled = false;
    };
    this.refresh = () => {
        if (on_translate !== null) {
            on_translate(state);
        }
        if (on_scale !== null) {
            on_scale(state);
        }
        if (on_change !== null) {
            on_change(state);
        }
        propagate();
    };
};

export default Transform;
